import { render, staticRenderFns } from "./NewUploadFileDetail.vue?vue&type=template&id=1686ca96&scoped=true"
import script from "./NewUploadFileDetail.vue?vue&type=script&lang=js"
export * from "./NewUploadFileDetail.vue?vue&type=script&lang=js"
import style0 from "./NewUploadFileDetail.vue?vue&type=style&index=0&id=1686ca96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1686ca96",
  null
  
)

export default component.exports